// config/permissions.js

//
// 1) Define roles
//
export const ROLES = {
  ADMIN: "admin",
  STAFF: "staff",
  // Add more roles here if needed...
};

//
// 2) Define permissions
//
export const PERMISSIONS = {
  //-------------------------------------------------------------------------//


  //semeseter
  ADD_SEMESTER: "Create New Timeline",
  UPDATE_SEMESTER: "Update Timeline",
  DELETE_SEMESTER: "Delete Timeline",

  //==========

  // other staff
  VIEW_STAFF: "view Staff",
  ADD_STAFF: "Add Staff",
  EDIT_STAFF: "Edit Staff",
  ACTIVE_STAFF: "Activate Staff",
  DEACTIVE_STAFF: "Deactivate Staff",

  // ---------------------------------------------------------------
  // ROLE MANAGEMENT PERMISSIONS (NEW) 8
  // ---------------------------------------------------------------
  // Common Role Management
  CREATE_ROLE: "Create Role",
  EDIT_ROLE: "Edit Role",
  GET_ALL_ROLE: "Get All Role",
  ASSIGN_ROLE: "Assign Role",
  REMOVE_ROLE: "Remove Role",

  // =======================
  // Discussions Management
  // =======================
  CREATE_DISCUSSION: "Create Discussion",
  UPDATE_DISCUSSION: "Update Discussion",
  DELETE_DISCUSSION: "Delete Discussion",

  // ===================
  // Pages Management
  // ===================
  CREATE_PAGE: "Create Page",
  UPDATE_PAGE: "Update Page",
  DELETE_PAGE: "Delete Page",

  // =======================
  // Attendance Management
  // =======================
  VIEW_STAFF_ATTENDANCE: "View Staff Attendance",
  MARK_ATTENDANCE: "Mark Attendance",
  YEARLY_ATTENDANCE_FOR_STUDENT: "Get Yearly Attendance for Student",
  VIEW_LEAVE_REQUESTS: "View Leave Requests",
  MANAGE_LEAVE_APPROVAL: "Manage Leave Approval",

  // =========
  // Notices
  // =========
  ADD_NEW_NOTICE: "Add New Notice",
  UPDATE_NOTICE: "Update Notice",
  REMOVE_NOTICE: "Remove Notice",

  // =======
  // Events
  // =======
  ADD_NEW_EVENT: "Add New Event",
  UPDATE_EVENT: "Update Event",
  REMOVE_EVENT: "Remove Event",

  // Finance 

  // receipt
  CANCEL_RECEIPTS: "Cancel receipt",
  SHOW_RECIEPT_SECTION: "show reciept section",
  ADD_NEW_RECIEPT: "add new reciept",

  //quotation
  SHOW_QUOTATION_SECTION: "View Quotations",
  CREATE_NEW_QUOTATION: "Create new quotation",
  ACCEPT_QUOTATION: "Accept quotation",
  REJECT_QUOTATION: "Reject quotation",


  FINANCE_CATEGORIES: "View Finance Categories",
  ADD_CATEGORIES: "Add Categories",
  EDIT_CATEGORY: "Edit Category",

  VIEW_INVENTORY: "View Inventory",
  ADD_NEW_INVENTORY_ITEM: "Add Inventory Item",
  EDIT_INVENTORY_ITEM: "Edit Inventory Item",

  SHOW_ENTITIES: "View Entities",
  ADD_NEW_ENTITY: "Add Entity",
  EDIT_ENTITY: "Edit Entity",

  VIEW_MORE_FEES_INVOICE: "view more fees invoice",
  CREATE_EXPENSES: "Create Operational Expense",
  UPDATE_EXPENSE: "Update Operatinal Expense",
  SHOW_OPERATIONAL_SECTION: "View Operational Expenses",
  CANCEL_EXPENSE_RECEIPT: "Cancel Expense Receipt",

  SHOW_PAYROLL_SECTION: "View Payrolls",
  CREATE_NEW_PAYROLL: "Create Payroll",
  UPDATE_PAYROLL: "Update Payroll",
  DELETE_PAYROLL: "Delete Payroll",

  SHOW_ENTITY_REVENUE_SECTION: "View Entity Revenue",
  ADD_NEW_INVOICE: "Add Entity Revenue Invoice",
  CANCEL_ENTITY_REVENUE_INVOICE: "Cancel Entity revenue",

  VIEW_BUDGET: "View Budget",
  CREATE_BUDGET: "Create Budget",
  EDIT_BUDGET: "Edit Budget",
  START_RECONCILIATION: "Start Reconciliation",
  VIEW_RECONCILIATION: "View Reconciliation",
  APPLY_FINANCE_CONFIGURATION: "Apply Configuration",
  DELETE_FINANCE_CONFIGURATION: "Delete Configuration",
  VIEW_FINANCE_CONFIGURATION: "View Finance Configuration",
  EDIT_PENALTY: "Edit Penalty",
  ADD_PENALTY: "Add Penalty",
  VIEW_PENALTY: "View Penalty",

  //FINANCE / LIABILITES
  VIEW_LIABILITIES: "View Liabilites",
  ADD_LIABILITY: "Add Liability",
  EDIT_LIABILITY: "Edit Liability",
  DELETE_LIABILITY: "Delete Liability",
  PAY_LIABILITY: "Pay Liability",

  VIEW_FINANCIAL_STATEMENTS: "View Financial Statements",
  VIEW_FINANCIAL_OVERVIEW: "View Finance Overview",
  VIEW_DAYBOOK: "View DayBook",

  VIEW_VOUCHERS: "View Vouchers",
  ADD_VOUCHERS: "Add Vouchers",
  EDIT_VOUCHERS: "Edit Vouchers",
  DELETE_VOUCHERS: "Delete Vouchers",

  VIEW_FIXED_ASSETS: "View Fixed Assets",
  ADD_FIXED_ASSETS: "Add Fixed Assets",
  EDIT_FIXED_ASSETS: "Edit Fixed Assets",
  DELETE_FIXED_ASSETS: "Delete Fixed Assets",


  VIEW_SHARE_HOLDERS: "View Share Holders",
  ADD_SHARE_HOLDERS: "Add Share Holders",
  EDIT_SHARE_HOLDERS: "Edit Share Holders",
  DELETE_SHARE_HOLDERS: "Delete Share Holders",


  // Transport Permissions
  SHIFT_MANAGEMENT: "View Shift Management",
  ADD_TRANSPORT_SHIFT: "Add Shift",
  EDIT_TRANSPORT_SHIFT: "Edit Shift",
  DEACTIVATE_TRANSPORT_SHIFT: "Deactivate Shift",
  DELETE_TRANSPORT_SHIFT: "Delete Shift",
  ADD_DRIVER: "Add Driver",
  ADD_HELPER: "Add Helper",
  VIEW_DRIVER_LIST: "View Drivers",
  EDIT_DRIVER: "Edit Driver",
  DELETE_DRIVER: "Delete Driver",
  EDIT_HELPER: "Edit Helper",
  DELETE_HELPER: "Delete Helper",
  VIEW_HELPER_LIST: "View Helpers",
  ADD_NEW_DRIVER_ASSIGNMENT: "Add New Driver Assignment",
  VIEW_DRIVER_ASSIGNMENT_LIST: "View Driver Assignment",
  EDIT_DRIVER_ASSIGNMENT: "Edit Driver Assignment",
  ADD_SUB_ROUTE: "Add SubRoutes",
  ADD_ROUTE: "Add Routes",
  VIEW_ROUTE_LIST: "View Route List",
  EDIT_ROUTE: "Edit Route",
  DELETE_ROUTE: "Delete Route",
  ASSIGN_VEHICLE_TO_ROUTE: "Assign Vehicle to Route",
  EDIT_ASSIGNED_VEHICLE: "Edit Assigned Vehicle",
  DELETE_ASSIGNED_VEHICLE: "Delete Assigned Vehicle",
  ADD_USERS_TO_ROUTE: "Add Users to Route",
  CREATE_TRIP: "Create Trip",
  VIEW_SCHEDULE_LIST: "View Vehicle Schedule",
  VEHICLE_LIST: "Vehicle List",
  ADD_VEHICLE: "Add Vehicle",
  EDIT_VEHICLE: "Edit Vehicle",
  DELETE_VEHICLE: "Delete Vehicle",
  VIEW_TRIP_LIST: "View Trip List",

  // Application requests
  ADD_APPLICATION_REQUEST: "Create Application Request",
  VIEW_APPLICATION_REQUESTS: "View Application Requests",
  UPDATE_APPLICATION_REQUEST: "Update Application Request",

  //Project Management
  ADD_PROJECT_MANAGEMENT: "Add Project",
  ADD_NEW_TASK: "Add Task",
  EDIT_TASK: "Edit Task",

  //Visitor Management
  VIEW_VISITOR_MANAGEMENT: "View Visitor Management",
  ADD_VISITOR: "Add Visitor",
  PRE_REGISTRATION: "Pre Registration",

  //Benifits Management
  VIEW_BENEFITS_MANAGEMENT: "View Benefits Management",
  ADD_BENEFIT: "Add Benefit",
  EDIT_BENEFITS: "Edit Benefit",
  MANAGE_APPROVALS: "Manager Approvals",
  VIEW_AUDIT: "View Audit",
  ISSUE_BENEFITS: "Issue Benefit",

  //Certificates & Letters Management
  VIEW_LETTER_CERTIFICATION_SECTION: "Certificates & Letters Management",
  GENERATE_TEMPLATE: "Generate Templates",
  ADD_TEMPLATE: "Add Template",
  EDIT_TEMPLATE: "Edit Template",
  DELETE_TEMPLATE: "Delete Template",
  VIEW_SIGNATURES: "View Digital Signatures",
  ADD_SIGNATURE: "Add Signature",
  EDIT_SIGNATURE: "Edit Signature",
  DELETE_SIGNATURE: "Delete Signature",
  VIEW_STAMPS: "View Stamps",
  ADD_STAMP: "Add Stamp",
  EDIT_STAMP: "Edit Stamp",
  DELETE_STAMP: "Delete Stamp",

  // Documents Management
  VIEW_DOCUMENT_MANAGEMENT: "View Documents Management",
  ADD_DOCUMENT: "Add Document",
  EDIT_DOCUMENT: "Edit Document",
  DELETE_DOCUMENT: "Delete Document",

  VIEW_JOB_POSTING: "View Jobs",
  CREATE_JOB: "Create Job",
  EDIT_JOB_POSTING: "Edit Job",
  DELETE_JOB: "Delete Job",
  EXPORT_JOB: "Export Job",
  EDIT_JOB_POSTING_STATUS: "Edit Job Status",
  VIEW_JOB_APPLICANTS: "Viw Job Applicants",
  SCHEDULE_JOB_INTERVIEW: "Schedule Job Interview",
  ASSIGN_HR_JOB: "Assign HR",
  MOVE_TO_NEXT_ROUND: "Update Round",
  APRROVE_REJECT_CANDIDATE: "Update Candidate Status",
  EDIT_JOB_INTERVIEW: "Edit Job Interview",
  EVALUATE_JOB_INTERVIEW: "Evaluate Job Interview",
};
